import { FC, ReactElement } from 'react';
import { Icons } from '~/assets/fonts/Icons/icons';
import theme from '~/constants/styles';
import CustomTooltip, { ICustomTooltipProps, TOOLTIP_POSITION } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import Icon from '~/view/components/Controls/Icon/Icon';

interface IProps extends Partial<ICustomTooltipProps> {
  iconId?: string;
  iconSize?: number;
  iconClassName?: string;
}

const TooltipIcon: FC<IProps> = ({
  iconId,
  iconSize = 16,
  iconClassName,
  position = TOOLTIP_POSITION.FIXED,
  ...props
}: IProps): ReactElement | null => {
  if (!props.message) return null;

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <CustomTooltip {...props} position={position}>
      <Icon id={iconId} name={Icons.Info} color={theme.colors.gray2} size={iconSize} className={iconClassName} />
    </CustomTooltip>
  );
};

export default TooltipIcon;
